import { CALL_API } from 'redux-api-middleware'
import { get, post, put } from 'utils/network'
import isInt from 'validator/lib/isInt'

export const searchStudent = (studentID) => {
  const request = get('/students/search', { q: studentID, by: 'id' })
  request.types = ['NOOP', 'NOOP', 'NOOP']
  return { [CALL_API]: request }
}

export const fetchLastOrno = () => {
  const request = get('/collections/last-orno')
  request.types = ['PAY_REQ', 'PAY_LASTOR_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchCollectionToday = () => {
  const request = get('/collections/today')
  request.types = ['PAY_REQ', 'PAY_GET2D_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const savePayment = (payload) => {
  let request = null
  if (payload.get('id')) {
    request = put(`/collections/${payload.get('id')}`, payload)
  } else {
    request = post('/collections', payload)
  }
  request.types = ['PAY_REQ', 'PAY_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchPayment = (id) => (dispatch, getState) => {
  // cache
  if (getState().payment.getIn(['item', 'id']) === id) {
    return Promise.resolve()
  }
  const request = get(`/collections/${id}`)
  request.types = ['PAY_REQ', 'PAY_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}

export const searchPayment = (input) => {
  const query = {
    q: input,
    by: isInt(input) ? 'or' : 'payee',
  }
  const request = get('/collections/search', query)
  request.types = ['PAY_Q_REQ', 'PAY_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const loadUnpaidBilling = (studentID) => {
  const request = get(`/billings/${studentID}/unpaid`)
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Payments/actions.js